import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Document, Folder } from '@lockton-apps/shared/interfaces';
import {
  ConfirmationDialogComponent,
  ConfirmDialogData,
} from '@lockton-apps/shared/ui/lui';

import { ConfirmDeleteDocumentDialogComponent } from './confirm-delete-document-dialog.component';
import { ConfirmDeleteFolderDialogComponent } from './confirm-delete-folder-dialog.component';

export enum ClientDocumentDeleteTarget {
  File,
  Folder,
}

@Injectable({
  providedIn: 'root',
})
export class DocumentsDialogService {
  constructor(private dialog: MatDialog) {}

  confirmDelete(entity: Document | Folder) {
    const data =
      'fileName' in entity
        ? { name: entity.fileName, target: ClientDocumentDeleteTarget.File }
        : { name: entity.name, target: ClientDocumentDeleteTarget.Folder };

    return this.dialog
      .open<ConfirmationDialogComponent, ConfirmDialogData, boolean>(
        ConfirmationDialogComponent,
        {
          maxWidth: 640,
          width: '100%',
          data: {
            content: ConfirmDeleteDocumentDialogComponent,
            contentData: {
              inputs: {
                name: data.name,
                target: data.target,
              },
            },
            confirmButtonText: $localize`Delete ${
              data.target === ClientDocumentDeleteTarget.Folder
                ? 'folder'
                : 'file'
            }`,
            cancelButtonText: $localize`Cancel`,
          },
        }
      )
      .afterClosed();
  }

  confirmDeleteFolder(folder: Folder, documents: Document[]) {
    return this.dialog
      .open<ConfirmationDialogComponent, ConfirmDialogData, boolean>(
        ConfirmationDialogComponent,
        {
          maxWidth: 640,
          width: '100%',
          data: {
            content: ConfirmDeleteFolderDialogComponent,
            contentData: {
              inputs: {
                name: folder.name,
                documents: documents,
              },
            },
            confirmButtonText: $localize`Delete folder`,
            cancelButtonText: $localize`Cancel`,
          },
        }
      )
      .afterClosed();
  }
}
